import { BackButton } from "../../../../../components/features/BackButton";
import { FragranceProfilerDetailedResults } from "./FragranceProfilerDetailedResults";
import { FragranceProfilerResults } from "../../../types/FragranceProfilerResults";

type FragranceProfilerResultsProps = {
  onBack: () => void;
  getResults: () => FragranceProfilerResults | null;
};

export const FragranceProfilerResultsPage = ({
  onBack,
  getResults,
}: FragranceProfilerResultsProps) => {
  const results = getResults();
  console.log("Fragrance Profiler Results: ", results);
  return (
    <div className="relative h-full w-full">
      <div className="absolute bottom-8 left-8 z-10 text-white">
        <BackButton onClick={onBack} />
      </div>
      <FragranceProfilerDetailedResults results={results} />
    </div>
  );
};
